"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TYPE_META = {
  delay: {
    title: '延期停车月卡',
    tag: '延期'
  },
  unfreeze: {
    title: '提前结束冻结',
    tag: '解冻'
  },
  freeze: {
    title: '冻结停车月卡',
    tag: '冻结'
  }
};
function pick(obj, keys, fallback) {
  if (fallback === undefined) fallback = '';
  for (var i = 0; i < keys.length; i++) {
    var val = obj[keys[i]];
    if (val !== undefined && val !== null && val !== '') return val;
  }
  return fallback;
}
function parseTime(val) {
  if (!val) return null;
  var t = new Date(String(val).replace(/-/g, '/').replace('T', ' ')).getTime();
  return Number.isNaN(t) ? null : t;
}
function formatDate(val) {
  if (!val) return '';
  return String(val).replace('T', ' ').slice(0, 10);
}
function formatDateTime(val) {
  if (!val) return '';
  var s = String(val).replace('T', ' ');
  return s.length >= 19 ? s.slice(0, 19) : s;
}
function calendarDays(start, end) {
  var s = parseTime(start);
  var e = parseTime(end);
  if (s == null || e == null) return '';
  var startDay = new Date(s);
  startDay.setHours(0, 0, 0, 0);
  var endDay = new Date(e);
  endDay.setHours(0, 0, 0, 0);
  return Math.round((endDay.getTime() - startDay.getTime()) / 86400000) + 1;
}
function resolveType(raw) {
  var typeMap = {
    1: 'freeze',
    2: 'delay',
    3: 'unfreeze',
    4: 'unfreeze'
  };
  if (typeMap[raw.operationType]) return typeMap[raw.operationType];
  var t = String(raw.operationName || '').toLowerCase();
  if (t.includes('delay') || t.includes('延期')) return 'delay';
  if (t.includes('unfreeze') || t.includes('解冻') || t.includes('提前')) return 'unfreeze';
  if (t.includes('freeze') || t.includes('冻结')) return 'freeze';
  return '';
}
function fileField(name, url) {
  if (!name && !url) return {
    label: '附件',
    value: '--'
  };
  return {
    label: '附件',
    value: "\u67E5\u770B\u9644\u4EF6\uFF1A".concat(name || '附件'),
    isFile: true,
    url: url || ''
  };
}
var _default2 = exports.default = {
  name: 'CardStatusChangeRecords',
  props: {
    records: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showAll: false,
      expandedMap: {}
    };
  },
  computed: {
    normalized: function normalized() {
      var _this = this;
      var list = (this.records || []).map(function (raw, index) {
        return _this.normalizeRecord(raw, index);
      }).filter(function (item) {
        return item && item.type;
      });
      return list.sort(function (a, b) {
        return (parseTime(b.operateTime) || 0) - (parseTime(a.operateTime) || 0);
      });
    },
    visibleRecords: function visibleRecords() {
      if (this.showAll) return this.normalized;
      return this.normalized.slice(0, 1);
    }
  },
  watch: {
    records: {
      handler: function handler() {
        this.showAll = false;
        this.expandedMap = {};
      },
      deep: true
    }
  },
  methods: {
    toggleExpand: function toggleExpand(key) {
      this.$set(this.expandedMap, key, !this.expandedMap[key]);
    },
    onFileClick: function onFileClick(field) {
      if (field.url) {
        window.open(field.url, '_blank');
        return;
      }
      this.$message.info(field.value);
    },
    normalizeRecord: function normalizeRecord(raw, index) {
      if (!raw) return null;
      var type = resolveType(raw);
      if (!type) return null;
      var meta = TYPE_META[type];
      var operator = this.formatOperator(raw);
      var operateTime = formatDateTime(raw.operationTime);
      var reason = raw.reason;
      var fileName = raw.attachmentName;
      var fileUrl = raw.attachmentUrl;
      var built = type === 'delay' ? this.buildDelay(raw, reason, fileName, fileUrl) : type === 'unfreeze' ? this.buildUnfreeze(raw, reason, fileName, fileUrl) : this.buildFreeze(raw, fileName, fileUrl);
      return {
        key: String(pick(raw, ['id'], "".concat(type, "-").concat(operateTime, "-").concat(index))),
        type: type,
        title: raw.operationName || meta.title,
        tag: meta.tag,
        operateTime: operateTime,
        summary: built.summary,
        fields: [{
          label: '操作人',
          value: operator || '--'
        }].concat(built.fields)
      };
    },
    formatOperator: function formatOperator(raw) {
      var name = raw.operatorName;
      var id = raw.operatorId;
      if (name && id && String(name).indexOf('[') === -1) return "".concat(name, "[").concat(id, "]");
      return name;
    },
    buildDelay: function buildDelay(raw, reason, fileName, fileUrl) {
      var days = raw.changeDays;
      var expireBefore = formatDateTime(raw.beforeEndTime);
      var expireAfter = formatDateTime(raw.afterEndTime);
      return {
        summary: "\u5EF6\u671F".concat(days || '--', "\u5929\uFF0C\u6708\u5361\u5230\u671F\u65F6\u95F4\u7531 ").concat(formatDate(expireBefore) || '--', " \u5EF6\u957F\u81F3 ").concat(formatDate(expireAfter) || '--'),
        fields: [{
          label: '延期时长',
          value: days ? "".concat(days, "\u5929") : '--'
        }, {
          label: '延期前到期',
          value: expireBefore || '--'
        }, {
          label: '延期后到期',
          value: expireAfter || '--'
        }, {
          label: '操作原因',
          value: reason || '--'
        }, fileField(fileName, fileUrl)]
      };
    },
    buildUnfreeze: function buildUnfreeze(raw, reason, fileName, fileUrl) {
      var freezeStart = formatDateTime(raw.freezeStartTime);
      var unfreezeTime = formatDateTime(raw.freezeEndTime);
      var result = '月卡立即恢复生效';
      return {
        summary: "".concat(raw.operationName || '结束冻结', "\uFF0C\u6708\u5361\u6062\u590D\u751F\u6548"),
        fields: [{
          label: '冻结开始',
          value: freezeStart || '--'
        }, {
          label: '冻结结束',
          value: unfreezeTime || '--'
        }, {
          label: '操作结果',
          value: result || '--'
        }, {
          label: '操作原因',
          value: reason || '--'
        }, fileField(fileName, fileUrl)]
      };
    },
    buildFreeze: function buildFreeze(raw, fileName, fileUrl) {
      var freezeStart = formatDateTime(raw.freezeStartTime);
      var freezeEnd = formatDateTime(raw.freezeEndTime);
      var days = raw.changeDays || calendarDays(freezeStart, freezeEnd);
      var result = '冻结期间月卡不生效，冻结结束后自动恢复';
      return {
        summary: "\u51BB\u7ED3".concat(days || '--', "\u5929\uFF0C\u51BB\u7ED3\u671F\u95F4\u6708\u5361\u4E0D\u751F\u6548"),
        fields: [{
          label: '冻结开始',
          value: freezeStart || '--'
        }, {
          label: '冻结结束',
          value: freezeEnd || '--'
        }, {
          label: '冻结天数',
          value: days ? "".concat(days, "\u5929") : '--'
        }, {
          label: '操作结果',
          value: result || '--'
        }, {
          label: '操作原因',
          value: raw.reason || '--'
        }, fileField(fileName, fileUrl)]
      };
    }
  }
};